module.exports = __webpack_public_path__ + "static/media/ic-prix.08bde75b.svg";